module.exports = __webpack_public_path__ + "static/media/gryphon-white.d848fdbe.svg";